// extracted by mini-css-extract-plugin
module.exports = {"author":"userCard_author__1CvE5","authorThumb":"userCard_authorThumb__W8HvF","authorName":"userCard_authorName__1pnM-","created":"userCard_created__1DHa9"};